import "moment-timezone";

import moment from "moment";

const getTime = (dateString?: string): Date => {
  if (!dateString) {
    // const { NODE_ENV } = process.env;
    // if (NODE_ENV === "development") {
    //   return moment
    //     .tz(new Date("26 Nov 2020 20:10").toISOString(), "Asia/Bangkok")
    //     .toDate();
    // }

    return moment.tz("Asia/Bangkok").toDate();
  }

  return moment.tz(new Date(dateString).toISOString(), "Asia/Bangkok").toDate();
};

export default getTime;
